import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getFirestore, collection, query, orderBy, limit, getDocs, where } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const OncekiKasa = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sube = queryParams.get("sube")?.trim();
  
  // State'ler
  const [kasaData, setKasaData] = useState({});
  const [nakitKasa, setNakitKasa] = useState(0);
  const [bankaBakiyesi, setBankaBakiyesi] = useState(0); 
  const [krediKartiBakiyesi, setKrediKartiBakiyesi] = useState(0);
  const [lastDate, setLastDate] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  
  const navigate = useNavigate();
  const db = getFirestore();
  const auth = getAuth();

  const toSafeNumber = (value) => {
    if (typeof value === "number") return Number.isFinite(value) ? value : 0;
    if (typeof value === "string") {
      const normalized = value.trim().replace(/\./g, "").replace(",", ".");
      const parsed = Number(normalized);
      return Number.isFinite(parsed) ? parsed : 0;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  // KATEGORİLER (Genel Kategorisi Kaldırıldı)
  const categories = [
    {
      key: "sarrafiye",
      name: "Sarrafiye",
      field: "adet",
      items: [
        { key: "eskiZiynetCeyrek", label: "Eski Ziynet Çeyrek" },
        { key: "yeniZiynetCeyrek", label: "Yeni Ziynet Çeyrek" },
        { key: "eskiZiynetYarim", label: "Eski Ziynet Yarım" },
        { key: "yeniZiynetYarim", label: "Yeni Ziynet Yarım" },
        { key: "eskiZiynetTam", label: "Eski Ziynet Tam" },
        { key: "yeniZiynetTam", label: "Yeni Ziynet Tam" },
        { key: "eskiZiynetGremse", label: "Eski Ziynet 2.5'lu Gremse" },
        { key: "yeniZiynetGremse", label: "Yeni Ziynet 2.5'lu Gremse" },
        { key: "eskiZiynetBesli", label: "Eski Ziynet Beşli" },
        { key: "yeniZiynetBesli", label: "Yeni Ziynet Beşli" },
        { key: "cumhuriyetAtaCeyrek", label: "Cumhuriyet Ata Çeyrek" },
        { key: "cumhuriyetAtaYarim", label: "Cumhuriyet Ata Yarım" },
        { key: "cumhuriyetAta", label: "Cumhuriyet Ata" },
        { key: "cumhuriyetAtaGremse", label: "Cumhuriyet Ata 2.5'lu Gremse" },
        { key: "cumhuriyetAtaBesli", label: "Cumhuriyet Ata Beşli" },
        { key: "resatCeyrek", label: "Reşat Çeyrek" },
        { key: "resatYarim", label: "Reşat Yarım" },
        { key: "resat", label: "Reşat" },
        { key: "resatGremse", label: "Reşat 2.5'lu Gremse" },
        { key: "resatBesli", label: "Reşat Beşli" }
      ]
    },
    {
      key: "gramAltin",
      name: "Gram Altın",
      field: "adet",
      items: [
        { key: "birGram22Ayar", label: "1 Gram 22 Ayar" },
        { key: "yariGram22Ayar", label: "0.50 Gram 22 Ayar" },
        { key: "ceyrekGram22Ayar", label: "0.25 Gram 22 Ayar" },
        { key: "birGram24Ayar", label: "1 Gram 24 Ayar" },
        { key: "yariGram24Ayar", label: "0.50 Gram 24 Ayar" },
        { key: "ceyrekGram24Ayar", label: "0.25 Gram 24 Ayar" },
        { key: "ikiBucukGram24Ayar", label: "2.50 Gram 24 Ayar" },
        { key: "besGram24Ayar", label: "5 Gram 24 Ayar" },
        { key: "onGram24Ayar", label: "10 Gram 24 Ayar" },
        { key: "yirmiGram24Ayar", label: "20 Gram 24 Ayar" },
        { key: "elliGram24Ayar", label: "50 Gram 24 Ayar" },
        { key: "yuzGram24Ayar", label: "100 Gram 24 Ayar" }
      ]
    },
    {
      key: "hurda",
      name: "Hurda",
      field: "gram",
      items: [
        { key: "yirmiDortAyarHurda", label: "24 Ayar Hurda" },
        { key: "yirmiIkiAyarBilezikHurda", label: "22 Ayar Bilezik Hurda" },
        { key: "yirmiIkiAyarHurda", label: "22 Ayar Hurda" },
        { key: "yirmiBirAyarHurda", label: "21 Ayar Hurda" },
        { key: "onSekizAyarHurda", label: "18 Ayar Hurda" },
        { key: "onDortAyarHurda", label: "14 Ayar Hurda" },
        { key: "sekizAyarHurda", label: "8 Ayar Hurda" }
      ]
    },
    {
      key: "doviz",
      name: "Döviz",
      field: "adet",
      items: [
        { key: "tl", label: "TL - Türk Lirası" },
        { key: "usd", label: "USD - Amerikan Doları" },
        { key: "eur", label: "EUR - Euro" },
        { key: "gbp", label: "GBP - İngiliz Sterlini" },
        { key: "chf", label: "CHF - İsviçre Frangı" },
        { key: "aud", label: "AUD - Avustralya Doları" },
        { key: "cad", label: "CAD - Kanada Doları" },
        { key: "sar", label: "SAR - Suudi Arabistan Riyali" },
        { key: "aed", label: "AED - Birleşik Arap Emirlikleri Dirhemi" },
        { key: "qar", label: "QAR - Katar Riyali" },
        { key: "mad", label: "MAD - Fas Dirhemi" },
        { key: "jod", label: "JOD - Ürdün Dinarı" },
        { key: "kwd", label: "KWD - Kuveyt Dinarı" },
        { key: "cny", label: "CNY - Çin Yuanı" },
        { key: "rub", label: "RUB - Rus Rublesi" },
        { key: "bgn", label: "BGN - Bulgar Levası" }
      ]
    }
  ];

  useEffect(() => {
    const fetchOncekiKasa = async () => {
      setLoading(true);
      try {
        if (!sube) {
          setError('Şube bilgisi eksik.');
          setLoading(false);
          navigate("/subesecimi");
          return;
        }

        // 1. En son alınan Gün Sonu Raporunu bul
        const gunsonuQuery = query(
          collection(db, 'subeler', sube, 'gunsonukasa'),
          orderBy('timestamp', 'desc'),
          limit(1)
        );
        const gunsonuSnapshot = await getDocs(gunsonuQuery);
        
        if (!gunsonuSnapshot.empty) {
          const lastDoc = gunsonuSnapshot.docs[0];
          const data = lastDoc.data();
          const gunSonuTarihi = data.timestamp; // Raporun alındığı an
          
          setKasaData(data);
          setLastDate(lastDoc.id);
          
          // Nakit Kasa (Raporda varsa oradan al)
          const nakit = toSafeNumber(data.doviz?.tl?.adet);
          setNakitKasa(nakit);
          
          // --- BANKA BAKİYESİ HESAPLAMA ---
          let calculatedBanka = 0;
          
          if (data.bankaBakiyesi !== undefined) {
             calculatedBanka = toSafeNumber(data.bankaBakiyesi);
          } else {
             // Kayıtlı değilse hesapla:
             const gecmisBankaQuery = query(
                collection(db, 'subeler', sube, 'islemler'),
                where('timestamp', '<=', gunSonuTarihi), 
                where('havaleEft', '>', 0)
             );
             
             const bankaSnap = await getDocs(gecmisBankaQuery);
             
             bankaSnap.docs.forEach(doc => {
                const islem = doc.data();
                const miktar = parseFloat(islem.havaleEft) || 0;
                
                if (['Satış', 'Giriş'].includes(islem.islemTuru)) {
                   calculatedBanka += miktar;
                } else if (['Alış', 'Çıkış', 'İade', 'Değişim'].includes(islem.islemTuru)) {
                   calculatedBanka -= miktar;
                }
             });
          }
          
          setBankaBakiyesi(calculatedBanka);

          // --- KREDİ KARTI (SADECE BİR ÖNCEKİ GÜN) ---
          let calculatedKrediKarti = 0;
          const raporTarihi = new Date(lastDoc.id);
          if (!isNaN(raporTarihi.getTime())) {
            raporTarihi.setHours(0, 0, 0, 0);
            const ertesiGun = new Date(raporTarihi);
            ertesiGun.setDate(ertesiGun.getDate() + 1);

            const oncekiGunKrediKartiQuery = query(
              collection(db, 'subeler', sube, 'islemler'),
              where('timestamp', '>=', raporTarihi),
              where('timestamp', '<', ertesiGun)
            );

            const krediKartiSnap = await getDocs(oncekiGunKrediKartiQuery);
            krediKartiSnap.docs.forEach((docItem) => {
              const islem = docItem.data();
              const miktar = parseFloat(islem.krediKarti) || 0;
              if (miktar <= 0) return;

              if (['Satış', 'Giriş'].includes(islem.islemTuru)) {
                calculatedKrediKarti += miktar;
              } else if (['Alış', 'Çıkış', 'İade', 'Değişim'].includes(islem.islemTuru)) {
                calculatedKrediKarti -= miktar;
              }
            });
          }
          setKrediKartiBakiyesi(calculatedKrediKarti);
          setError('');
        } else {
          setError('Henüz alınmış bir gün sonu raporu bulunamadı.');
          setKasaData({});
        }
        setLoading(false);
      } catch (err) {
        console.error('Veri alma hatası:', err);
        setError(`Hata: ${err.message}`);
        setLoading(false);
      }
    };

    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) navigate("/login");
      else fetchOncekiKasa();
    });

    return () => unsubscribe();
  }, [sube, navigate, auth]);

  if (loading) return <div style={{display:'flex', justifyContent:'center', marginTop:'50px'}}>Yükleniyor...</div>;
  if (error) return <div style={{color:'red', textAlign:'center', marginTop:'50px'}}>{error}</div>;

  const categoryLayout = {
    sarrafiye: { productWidth: "275px", totalWidth: "350px" },
    gramAltin: { productWidth: "195px", totalWidth: "270px" },
    hurda: { productWidth: "215px", totalWidth: "285px" },
    doviz: { productWidth: "335px", totalWidth: "415px" },
  };

  return (
    <div className="ok-page" style={{
      background: "linear-gradient(180deg, #f8fafd 0%, #eff3f8 100%)",
      borderRadius: "12px",
      padding: "8px 10px 10px",
      boxShadow: "0 10px 24px rgba(15, 23, 42, 0.10)",
      border: "1px solid #d9e2ee",
      width: "1580px",
      height: "735px",
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
      fontFamily: "'Roboto', sans-serif",
      margin: "-10px 0 4px 0",
      position: "relative",
      overflow: "hidden",
    }}>
      <div
        className="ok-header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "0 4px 6px",
          padding: "4px 8px",
          borderBottom: "1px solid #dbe4ef",
        }}
      >
        <h2 className="ok-title" style={{ margin: 0, fontSize: "18px", fontWeight: 800, color: "#1e293b", letterSpacing: "0.2px" }}>
          Önceki kasa
        </h2>
        <span className="ok-date" style={{ fontSize: "13px", color: "#64748b", fontWeight: 700 }}>
          {lastDate ? `${lastDate.split('-').reverse().join('.')} tarihli kapanış` : 'Tarih bilgisi yok'}
        </span>
      </div>

      <div className="ok-main-wrap" style={{
        display: "flex",
        flexDirection: "row-reverse",
        alignItems: "flex-start",
        gap: "10px",
        flex: 1,
        minHeight: 0,
      }}>
        <div className="ok-sidebar" style={{
          width: "235px",
          background: "linear-gradient(180deg, #fffdf4 0%, #faf5e8 100%)",
          border: "1px solid #e4dac4",
          borderRadius: "8px",
          boxShadow: "0 4px 10px rgba(15, 23, 42, 0.06)",
          padding: "8px",
          flexShrink: 0,
        }}>
          <div className="ok-sidebar-branch" style={{ fontSize: "13px", fontWeight: 800, color: "#1f2937" }}>
            {sube ? sube.toUpperCase().replace("_", " ") : "ŞUBE"}
          </div>
          <div style={{ fontSize: "10px", color: "#64748b", fontWeight: 700, marginBottom: "8px" }}>
            Önceki kasa
          </div>
          <div className="ok-summary-grid" style={{ display: "grid", gap: "6px" }}>
            <div className="ok-summary-card" style={{ border: "1px solid #bff0d8", borderLeft: "6px solid #059669", borderRadius: "12px", padding: "11px 10px", minHeight: "82px", background: "#ffffff", display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ width: "44px", height: "44px", borderRadius: "50%", background: "linear-gradient(135deg, #06b27a 0%, #059669 100%)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: "24px", boxShadow: "0 6px 14px rgba(5,150,105,0.35)" }}>₺</div>
              <div>
                <div style={{ fontSize: "14px", color: "#64748b", fontWeight: 800, letterSpacing: "0.8px" }}>NAKİT</div>
                <div style={{ fontSize: "24px", color: "#0f172a", fontWeight: 900, lineHeight: 1, display: "flex", alignItems: "center", gap: "5px" }}>
                  {nakitKasa.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  <span style={{ fontSize: "24px", fontWeight: 900, color: "#334155", alignSelf: "flex-start", marginTop: "1px" }}>₺</span>
                </div>
              </div>
            </div>
            <div className="ok-summary-card" style={{ border: "1px solid #dbe7ff", borderLeft: "6px solid #2563eb", borderRadius: "12px", padding: "11px 10px", minHeight: "82px", background: "#ffffff", display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ width: "44px", height: "44px", borderRadius: "50%", background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: "20px", boxShadow: "0 6px 14px rgba(37,99,235,0.3)" }}>🏦</div>
              <div>
                <div style={{ fontSize: "14px", color: "#64748b", fontWeight: 800, letterSpacing: "0.8px" }}>BANKA</div>
                <div style={{ fontSize: "24px", color: "#0f172a", fontWeight: 900, lineHeight: 1, display: "flex", alignItems: "center", gap: "5px" }}>
                  {bankaBakiyesi.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  <span style={{ fontSize: "24px", fontWeight: 900, color: "#334155", alignSelf: "flex-start", marginTop: "1px" }}>₺</span>
                </div>
              </div>
            </div>
            <div className="ok-summary-card" style={{ border: "1px solid #ffd7bf", borderLeft: "6px solid #ea580c", borderRadius: "12px", padding: "11px 10px", minHeight: "82px", background: "#ffffff", display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ width: "44px", height: "44px", borderRadius: "50%", background: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: "20px", boxShadow: "0 6px 14px rgba(234,88,12,0.3)" }}>▭</div>
              <div>
                <div style={{ fontSize: "14px", color: "#64748b", fontWeight: 800, letterSpacing: "0.8px" }}>KREDİ KARTI</div>
                <div style={{ fontSize: "24px", color: "#0f172a", fontWeight: 900, lineHeight: 1, display: "flex", alignItems: "center", gap: "5px" }}>
                  {krediKartiBakiyesi.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  <span style={{ fontSize: "24px", fontWeight: 900, color: "#334155", alignSelf: "flex-start", marginTop: "1px" }}>₺</span>
                </div>
              </div>
            </div>
            <div className="ok-summary-card" style={{ border: "1px solid #ddd7ff", borderLeft: "6px solid #4f46e5", borderRadius: "12px", padding: "11px 10px", minHeight: "82px", background: "#ffffff", display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ width: "44px", height: "44px", borderRadius: "50%", background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: "22px", boxShadow: "0 6px 14px rgba(79,70,229,0.3)" }}>Σ</div>
              <div>
                <div style={{ fontSize: "14px", color: "#64748b", fontWeight: 800, letterSpacing: "0.8px" }}>TOPLAM</div>
                <div style={{ fontSize: "24px", color: "#0f172a", fontWeight: 900, lineHeight: 1, display: "flex", alignItems: "center", gap: "5px" }}>
                  {(toSafeNumber(nakitKasa) + toSafeNumber(bankaBakiyesi) + toSafeNumber(krediKartiBakiyesi)).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  <span style={{ fontSize: "24px", fontWeight: 900, color: "#334155", alignSelf: "flex-start", marginTop: "1px" }}>₺</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ok-columns" style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          overflow: "hidden",
          boxSizing: "border-box",
          flex: 1,
          justifyContent: "center",
          minHeight: 0,
        }}>
          {categories.map((category) => {
            const width = categoryLayout[category.key] || { productWidth: "220px", totalWidth: "300px" };
            return (
              <div key={category.key} className="ok-col" data-kategori={category.key} style={{
                width: width.totalWidth,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                boxSizing: "border-box",
                background: "#ffffff",
                border: "1px solid #dfe7f2",
                borderRadius: "8px",
                boxShadow: "0 4px 10px rgba(15, 23, 42, 0.05)",
              }}>
                <h3 style={{ fontSize: "12px", fontWeight: 800, margin: "0", padding: "5px 6px", color: "#334155", borderBottom: "1px solid #e5ebf3", background: "#f8fbff" }}>{category.name}</h3>
                <table className="ok-table" style={{
                  width: "100%",
                  borderCollapse: "separate",
                  borderSpacing: "0",
                  fontSize: "11px",
                  color: "#1f2937",
                  lineHeight: "1.2",
                  boxSizing: "border-box",
                  fontWeight: "700",
                }}>
                  <thead>
                    <tr>
                      <th style={{ border: "1px solid #e5e7eb", borderBottom: "1px solid #c58a2f", padding: "4px 5px", width: width.productWidth, fontWeight: "800", fontSize: "11px", textAlign: "left", background: "#f3f7fd" }}>
                        Ürün
                      </th>
                      <th style={{ border: "1px solid #e5e7eb", borderBottom: "1px solid #c58a2f", padding: "4px 4px", width: "60px", fontWeight: "800", fontSize: "11px", textAlign: "center", background: "#f3f7fd" }}>
                        {category.key === "hurda" ? "Gram" : (category.key === "doviz" ? "Birim" : "Adet")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {category.items.map((item) => {
                      const value = kasaData?.[category.key]?.[item.key]?.[category.field] || 0;
                      return (
                        <tr key={item.key}>
                          <td style={{
                            border: "1px solid #e5e7eb",
                            borderRight: "1px solid #e5e7eb",
                            padding: "5px 6px",
                            width: width.productWidth,
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            boxSizing: "border-box",
                            fontWeight: 700,
                            fontSize: "14px",
                            color: "#0f172a",
                          }}>
                            {item.label}
                          </td>
                          <td style={{
                            border: "1px solid #e5e7eb",
                            borderRight: "1px solid #e5e7eb",
                            padding: "5px 4px",
                            width: "60px",
                            boxSizing: "border-box",
                            textAlign: "center",
                            fontSize: "15px",
                            fontWeight: 700,
                            color: value < 0 ? "#ef4444" : "#0f172a",
                            fontFamily: "Consolas, monospace",
                          }}>
                            {value.toLocaleString('tr-TR', {
                              minimumFractionDigits: (category.key === "hurda" || category.key === "doviz") ? 2 : 0,
                              maximumFractionDigits: 2
                            })}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            );
          })}
        </div>
      </div>
      <style>
        {`
        /* --- TELEFON (<=560px): kasa listesi tek ekrana yaklassin ---
           Satirlar sikisti; kisa isimli kategoriler (Gram Altin / Hurda /
           Doviz) iki sutuna dizildi. Sarrafiye isimleri uzun: tek sutun.
           Masaustu duzenine dokunulmaz. */
        @media (max-width: 560px) {
          .ok-page .ok-col h3 { position: sticky; top: 0; z-index: 2; padding: 6px 8px !important; font-size: 12.5px !important; }
          .ok-page .ok-table th, .ok-table td { padding: 2px 6px !important; font-size: 12px !important; }
          .ok-page .ok-col[data-kategori="sarrafiye"] .ok-table thead,
          .ok-page .ok-col[data-kategori="gramAltin"] .ok-table thead,
          .ok-page .ok-col[data-kategori="hurda"] .ok-table thead,
          .ok-page .ok-col[data-kategori="doviz"] .ok-table thead { display: none; }
          .ok-page .ok-col[data-kategori="sarrafiye"] .ok-table tbody,
          .ok-page .ok-col[data-kategori="gramAltin"] .ok-table tbody,
          .ok-page .ok-col[data-kategori="hurda"] .ok-table tbody,
          .ok-page .ok-col[data-kategori="doviz"] .ok-table tbody { display: grid; grid-template-columns: 1fr 1fr; column-gap: 6px; }
          .ok-page .ok-col[data-kategori="sarrafiye"] .ok-table tbody tr,
          .ok-page .ok-col[data-kategori="gramAltin"] .ok-table tbody tr,
          .ok-page .ok-col[data-kategori="hurda"] .ok-table tbody tr,
          .ok-page .ok-col[data-kategori="doviz"] .ok-table tbody tr { display: grid; grid-template-columns: minmax(0, 1fr) auto; align-items: center; border-bottom: 1px solid #eef2f7; }
          .ok-page .ok-col[data-kategori="sarrafiye"] .ok-table tbody td,
          .ok-page .ok-col[data-kategori="gramAltin"] .ok-table tbody td,
          .ok-page .ok-col[data-kategori="hurda"] .ok-table tbody td,
          .ok-page .ok-col[data-kategori="doviz"] .ok-table tbody td { width: auto !important; min-width: 0 !important; border: none !important; padding: 2px 4px !important; font-size: 11px !important; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
        }

          .ok-table tbody tr:nth-child(odd) td {
            background: #fcfdff;
          }

          /* --- MOBİL: Önceki Kasa (masaüstü inline stillere dokunulmaz) --- */
          /* Kompakt duzen: telefonlar + dokunmatik tabletler. Sayfa kabuğu
             1580px genisliginde yerlesiyordu ve tablette tasiyordu. */
          @media (max-width: 1649px), (max-width: 1400px) and (any-pointer: coarse) {
            .ok-page {
              display: block !important;
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              min-height: 0 !important;
              margin: 0 !important;
              padding: 8px 4px 80px !important;
              overflow: visible !important;
              box-sizing: border-box !important;
              position: static !important;
            }

            .ok-header {
              display: flex !important;
              flex-direction: column !important;
              align-items: flex-start !important;
              gap: 4px !important;
              margin: 0 0 10px !important;
              padding: 0 2px 8px !important;
            }

            .ok-title {
              font-size: 17px !important;
            }

            .ok-date {
              font-size: 12px !important;
              line-height: 1.35 !important;
            }

            .ok-main-wrap {
              display: block !important;
              flex: none !important;
              height: auto !important;
              min-height: 0 !important;
              overflow: visible !important;
            }

            .ok-sidebar {
              width: 100% !important;
              max-width: 100% !important;
              margin: 0 0 12px !important;
              padding: 10px !important;
              box-sizing: border-box !important;
            }

            .ok-summary-grid {
              display: grid !important;
              /* Tek sutunda her kartin sagi bostu; ikiserli diziliyor */
              grid-template-columns: 1fr 1fr !important;
              gap: 6px !important;
            }

            .ok-summary-grid > *:last-child {
              grid-column: 1 / -1 !important;
            }

            .ok-summary-card {
              min-height: 0 !important;
              padding: 10px !important;
              flex-direction: row !important;
              align-items: center !important;
              gap: 10px !important;
            }

            .ok-summary-card > div:first-child {
              width: 40px !important;
              height: 40px !important;
              font-size: 18px !important;
              flex-shrink: 0 !important;
            }

            .ok-summary-card > div:last-child > div:first-child {
              font-size: 12px !important;
            }

            .ok-summary-card > div:last-child > div:last-child {
              font-size: 20px !important;
            }

            .ok-summary-card > div:last-child > div:last-child span {
              font-size: 20px !important;
            }

            .ok-columns {
              display: block !important;
              flex: none !important;
              height: auto !important;
              min-height: 0 !important;
              overflow: visible !important;
              width: 100% !important;
            }

            .ok-col {
              display: block !important;
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              min-height: 0 !important;
              overflow: visible !important;
              margin: 0 0 12px !important;
              box-sizing: border-box !important;
            }

            .ok-col:last-child {
              margin-bottom: 0 !important;
            }

            .ok-col h3 {
              font-size: 13px !important;
              padding: 7px 8px !important;
            }

            .ok-table {
              display: table !important;
              width: 100% !important;
              table-layout: fixed !important;
              font-size: 12px !important;
            }

            .ok-table th,
            .ok-table td {
              padding: 6px 6px !important;
              width: auto !important;
              max-width: none !important;
            }

            .ok-table th:first-child,
            .ok-table td:first-child {
              width: auto !important;
            }

            .ok-table th:last-child,
            .ok-table td:last-child {
              width: 72px !important;
              min-width: 72px !important;
              max-width: 72px !important;
            }

            .ok-table td:first-child {
              font-size: 13px !important;
              line-height: 1.25 !important;
              word-break: break-word !important;
            }

            .ok-table td:last-child {
              font-size: 14px !important;
            }
          }
        `}
      </style>
    </div>
  );
}

export default OncekiKasa;